import React from 'react';
import { forEach } from 'lodash';

import Form from '~/components/SecurityGroup/Form';

import ReferenceDataProvider from '~/utils/reference-data/context';

import {
  referenceAdminInstance as RefAdmin,
} from '~/utils';

const SecurityGroups = () => (
  <ReferenceDataProvider
    type="ReferenceSecurityGroup"
    config={{
      initialValues: { isClientManaged: true },
      customFields: {
        permissions: {
          component: Form,
        },
      },
      actions: {
        afterRootSubmitSuccess: ({ r, values }) => {
          const promises = [];
          const { spfr, permissions } = values;
          const { data: { data } } = r;

          const isActive = spfr.filter(i => i.attributes.isActive);
          const isInactive = spfr.filter(i => !i.attributes.isActive);
          const newPermissions = permissions.filter(p =>
            !spfr.map(i => i.attributes.securityPermissionUid).includes(p.id));

          forEach(isActive, (i) => {
            if (!permissions.map(p => p.id).includes(i.attributes.securityPermissionUid)) {
              console.log('active, but not here', i);
              promises.push(RefAdmin
                .delete(`reference-security-group-security-permission/${i.id}`));
            }
          });

          forEach(isInactive, (i) => {
            if (permissions.map(p => p.id).includes(i.attributes.securityPermissionUid)) {
              console.log('inactive, but here', i);
              promises.push(RefAdmin
                .put(`reference-security-group-security-permission/${i.id}`, {
                  securityPermissionUid: i.attributes.securityPermissionUid,
                  securityGroupUid: data.id,
                  isActive: true,
                }));
            }
          });

          forEach(newPermissions, p =>
            promises.push(RefAdmin
              .post('reference-security-group-security-permission', {
                securityPermissionUid: p.id,
                securityGroupUid: data.id,
                isActive: true,
              })));
        },
      },
    }}
  />
);

export default SecurityGroups;
